
/**
 * @author Sai Prasad
 * @class SuiteExtraInfo
 */

import React from 'react';

const SuiteExtraInfo = ({
    title,
    message,
    items
}) => {
    return (
        <li>
            {title} :{" "}
            <span>
                {items &&
                    items.length > 0
                    ? items.map((item, index) => {
                        return (
                            item.name +
                            (items.length - 1 ===
                                index
                                ? ""
                                : ", ")
                        );
                    })
                    : message}
            </span>
        </li>
    )
}

export default SuiteExtraInfo;
